import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler, dadataApi, loadersSlice } from 'Modules'
import { AddressSuggest } from 'Models'
import { leadApi, SberIdUserInfoNS, sberIdUserInfoSlice } from 'Pages/lead'

export function* getSberIdUserInfoSaga(action: SberIdUserInfoNS.GetSberIdUserInfo) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const data = yield* call(leadApi.getAfterSberIdUserInfo, action.payload)
		if (typeof data === 'object' && data !== null && Object.keys(data).length) {
			const query = data?.address_reg?.full_address ? data.address_reg.full_address : ''
			const res = yield* call(dadataApi.getAddress, { query, origin: 'rbidos_paid' }, 'address')
			yield* put(sberIdUserInfoSlice.actions.setOne({ dadataInfo: res[0], SberIdInfo: data }))
		} else {
			yield* put(
				sberIdUserInfoSlice.actions.setOne({ dadataInfo: {} as AddressSuggest, SberIdInfo: data })
			)
		}
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* sberIdUserInfoSaga() {
	yield* takeLatest(sberIdUserInfoSlice.actions.getSberIdUserInfo.type, getSberIdUserInfoSaga)
}
